// extracted by mini-css-extract-plugin
module.exports = {"inaccessible":"src-hello-react-components-debug-test-ids-module__inaccessible--JVEtg"};